<template>
	<div class="my-card-infos" ref="infoContainer">
		<span class="card-amount" v-html="$t('cards.amount', { current: currentCard, available: cardCount })"></span>
		<span class="current-card-indicator-bar" :style="indicatorWidthAndOffset"></span>
	</div>
</template>

<script>
	export default {
		name: 'MyCardInfos',
		data () {
			return {
				indicatorBarMargin: 32, // in px = 2rem
				containerWidth: 0,
				stepSize: 0,
				currentCard: 0, // 0 indexed
			}
		},
		computed: {
			cardCount () {
				return this.$store.getters.getCards.length
			},
			indicatorWidthAndOffset () {
				let percentage = this.stepSize * this.currentCard + 1
				return { transform: 'translate(' + percentage + '%, 0%)', width: this.stepSize + 'px' }
			}
		},
		mounted () {
			this.containerWidth = this.$refs.infoContainer.clientWidth - this.indicatorBarMargin
			this.stepSize = this.containerWidth / this.cardCount

			this.$eBus.$on('updated-selected-card', (sliderIndex) => {
				this.currentCard = sliderIndex
			})
		}
	}
</script>

<style lang="scss" scoped>
	.my-card-infos{
		.card-amount{
			display: block;
			text-align: center;
			text-transform: uppercase;
		}

		.current-card-indicator-bar{
			display: block;
			height: .25rem;
			border-radius: 20rem;
			background-color: get-color(primary);
			margin: 0 1rem;
		}
	}	
</style>
